import React from 'react';
import UIModal from '@/components/shared/UIModal';
import UIButton from '@/components/shared/UIButton';
import { AcceptInviteResponse } from '@/types/entities';
import './InviteSuccessModal.scss';

interface InviteSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  responseData: AcceptInviteResponse | null;
}

const baseClass = 'InviteSuccessModal';

const InviteSuccessModal: React.FC<InviteSuccessModalProps> = ({ isOpen, onClose, responseData }) => {
  if (!isOpen || !responseData || !responseData.lease) {
    return null;
  }

  // Дістаємо вкладені дані з нової структури
  const unitNumber = responseData.lease.unit?.number;
  const propertyName = responseData.lease.unit?.property?.name;

  return (
    <UIModal
      isOpen={true}
      onClose={onClose}
      title="Invitation Accepted!"
      size="small"
      closeOnBackdropClick={false}
      closeOnEscape={false}
    >
      <div className={`${baseClass}`}>
        <p className={`${baseClass}__text`}>
          You have successfully confirmed your lease for
          {unitNumber && <strong> Unit {unitNumber}</strong>}
          {propertyName && <span> at <strong>{propertyName}</strong></span>}.
        </p>
        <p className={`${baseClass}__subtext`}>Welcome! You can now manage your tenancy from your dashboard.</p>
        <div className={`${baseClass}__actions`}>
          <UIButton
            variant="primary"
            size="large"
            onClick={onClose}
            fullWidth
          >
            Go to My Tenancy
          </UIButton>
        </div>
      </div>
    </UIModal>
  );
};

export default InviteSuccessModal;
